import React, { useEffect, useRef, useState } from 'react';

import { EditableText } from '../../../report-builder/components/editable-text/editable-text';
import { usePredictionsInfoContext } from '../context/predictions-info-context';

const UPDATE_NAME_DELAY_TIME = 3000;

export const BudgetScenarioName = () => {
  const { forecast, isReadOnly, updateForecast } = usePredictionsInfoContext();

  const [name, setName] = useState(forecast?.name || '');

  const updateTimer = useRef<number | null>(null);

  useEffect(() => {
    if (updateTimer.current) {
      clearTimeout(updateTimer.current);
    }
    updateTimer.current = (setTimeout(() => {
      if (!isReadOnly && name !== forecast?.name && name.length && typeof updateForecast === 'function') {
        updateForecast({ name });
      }
    }, UPDATE_NAME_DELAY_TIME) as unknown) as number;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReadOnly, name]);

  useEffect(() => {
    setName(forecast?.name || '');
  }, [forecast?.name]);

  if (isReadOnly) {
    return <span>{forecast?.name || ''}</span>;
  }

  return (
    <div>
      <EditableText text={name} onTextChange={setName} size="small" initialText={forecast?.name || ''} />
    </div>
  );
};
